(function(){
    'use strict';
    /* global Bloodhound */

    var resources = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: 'http://development.tescloud.com/twigkit/services/query-suggestion-service/services.suggestions.resources?q=%QUERY',
            ajax: {
                dataType: 'jsonp',
                crossDomain: true
            },
            filter: function (response) {

                var suggestions = [];

                response[0].values.forEach(function (result) {
                    suggestions.push({
                        value: result.value.replace(/<\/?em>/g, ''),
                        highlighted: result.highlighting,
                        parameters: result.parameters
                    });
                });

                return suggestions;
            }
        }

    });

    resources.initialize();

    $('.typeahead').typeahead(null, {
        name: 'resources',
        displayKey: 'value',
        templates: {
            suggestion: function (suggestion) {
                return suggestion.highlighted;
            }
        },
        source: resources.ttAdapter()
    });

    $('.typeahead').on('typeahead:selected', function (e, selected) {
        window.location = window.location.origin + '/teaching-resources/search' + selected.parameters;
    });

})();